<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gSU4RS/tc-custom/9781466802117.jpg?1731799936504" alt="This image is the cover for the book Casting with a Fragile Thread"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Casting with a Fragile Thread
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this poignant, lyric memoir, a sister's tragic death prompts a woman's unbidden journey into her turbulent African past.</b><br/><br/>A comfortable suburban housewife with three children living in Connecticut, Wendy Kann thought she had put her volatile childhood in colonial Rhodesia—now Zimbabwe—behind her. Then one Sunday morning came a terrible phone call: her youngest sister, Lauren, had been killed on a lonely road in Zambia. Suddenly unable to ignore her longing for her homeland, she decides she must confront the ghosts of her past.<br/><br/>Wendy Kann's is a personal journey, set against a backdrop as exotic as it is desolate. From a privileged colonial childhood of mansions and servants, her story moves to a young adulthood marked by her father's death, her mother's insanity, and the viciousness of a bloody civil war. Through unlikely love she finds herself in the incongruous sophistication of Manhattan; three children bring the security of suburban America, until the heartbreaking vulnerability of the small child her sister left behind in Africa compels her to return to a continent she hardly recognizes.<br/><br/>With honesty and compassion, Kann pieces together her sister's life, explores the heartbreak of loss and belonging, and finally discovers the true meaning of home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wendy Kann
      </h2>
      
      <p class="authorDescription body article"><B>Wendy Kann</B> lives in Connecticut with her husband and children. <I>Casting with a Fragile Thread</I> is her first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6af75e54